import { IAirPlace } from "../../booking/air/IAirPlace";
import { ICodeName } from "../../shared/ICodeName";

export interface IAirSector {
    aircraft: string;
    begin: string;
    carrier: ICodeName;
    duration: {
        minutes: number;
    };
    end: string;
    flight: string;
    from: IAirPlace;
    key: {
        [host: string]: string;
    };
    seat: {
        [code: string]: string;
    };
    to: IAirPlace;
    xID: string;
}

export interface IAirSectorResult {
    end: string;
    from: IAirPlace;
    to: IAirPlace;
    begin: string;
    xType: SectorXType;
}
export enum SectorXType {
    air = "air",
    stay = "stay",
    vehicle = "vehicle"
}